import React from 'react';
import {Switch, Tooltip, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {FormikTextField} from '@src/components/FormikFields';
import {InfoCard} from '@src/modules/accountDashboard/components/InfoCard';

import {handleOnWheel, numberFilter} from '../../utils';

import styles from './assessmentResources.module.scss';
import {CreditDisclaimerCard} from './CreditDisclaimerCard';

export default function AssessmentResources({formik, totalCredits}){
    const {t} = useTranslation();

    const assessmentKey = 'companyId';
    const assessmentLabel = 'ACCOUNTS_PAGE.ASSESSMENT_CHECK';
    const assessmentDisabled = true;
    const isEnabled = !!formik?.values?.assessment?.[assessmentKey];
    const toggleLabel = isEnabled ? t('ACCOUNTS_PAGE.ENABLED') : t('ACCOUNTS_PAGE.DISABLED');

    return (
        <div className={styles.container}>
            <div className={styles.row}>
                <Typography variant='h6' component='h6' mt={3} mb={1}>
                    {t(assessmentLabel)}
                </Typography>
            </div>
            <div className={styles.row}>
                <div className={`${styles.item} ${styles.itemCenter} ${typeof totalCredits !== 'number' ? styles.fullItem : ''}`}>
                    <Tooltip title={toggleLabel}>
                        <Switch
                            disabled={assessmentDisabled}
                            onChange={() => formik.setFieldValue(`assessment.${assessmentKey}`, !formik.values?.assessment[assessmentKey])}
                            name={`assessment.${assessmentKey}`}
                            checked={isEnabled}
                            formik={formik}
                        />
                    </Tooltip>
                    <div>
                        {toggleLabel}
                    </div>
                </div>

                {typeof totalCredits === 'number' && <div className={styles.item}>
                    <InfoCard
                        className={'styles.itemValue'}
                        iconName={'Coin'}
                        name={t('ACCOUNTS_PAGE.TOTAL_CREDITS')}
                        total={totalCredits}
                    />
                </div>
                }

            </div>

            {formik?.values?.assessment?.companyId && <CreditDisclaimerCard />}

            <Typography variant='h6' component='h6' mt={3} mb={1}>
                {t('ACCOUNTS_PAGE.GENERAL_INFO')}
            </Typography>
            <div className={styles.column}>
                <div className={styles.itemCenter}>
                    <FormikTextField
                        className={styles.inputQuantity}
                        name='assessment.quantity'
                        data-qa='account-assessment-quantity'
                        label={t('ACCOUNTS_PAGE.ASSESSMENT_MONTHLY_CREDIT')}
                        formik={formik}
                        type='number'
                        fullWidth
                        onKeyPress={(e) => numberFilter(e)}
                        onWheel={handleOnWheel}
                        value={formik?.values?.assessment?.quantity}
                        onChange={(e) => formik.setFieldValue('assessment.quantity', e.target.value)}
                        error={Boolean(formik.touched.assessment?.quantity && formik.errors.assessment?.quantity)}
                        helperText={formik.touched.assessment?.quantity && formik.errors.assessment?.quantity}
                    />
                </div>

                <div className={styles.itemCenter}>
                    <FormikTextField
                        className={styles.inputQuantity}
                        name='assessment.credit_day'
                        data-qa='account-assessment-credit_day'
                        label={t('ACCOUNTS_PAGE.ASSESSMENT_CREDIT_DAY')}
                        formik={formik}
                        type='number'
                        fullWidth
                        onKeyPress={(e) => numberFilter(e)}
                        onWheel={handleOnWheel}
                        value={formik?.values?.assessment?.credit_day}
                        onChange={(e) => formik.setFieldValue('assessment.credit_day', e.target.value)}
                        error={Boolean(formik.touched.assessment?.credit_day && formik.errors.assessment?.credit_day)}
                        helperText={formik.touched.assessment?.credit_day && formik.errors.assessment?.credit_day}
                    />                    
                </div>
            </div>
        </div>
    );
}
